"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _flatMap = _interopRequireDefault(require("lodash/flatMap"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _emotion = require("emotion");

var _reactComponents = require("@cimpress/react-components");

var _addForm = _interopRequireDefault(require("../shared/addForm"));

var _dataSheetsContainer = _interopRequireDefault(require("./dataSheetsContainer"));

var _constraintComponent = _interopRequireDefault(require("./constraintComponent"));

var _ruleOrDataSheetPrompt = _interopRequireDefault(require("./ruleOrDataSheetPrompt"));

var _constraintActions = require("./constraintActions");

var _propTypes2 = require("../shared/propTypes");

var _keyValidators = require("../shared/validators/keyValidators");

var _rules = require("../validators/rules");

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100px;\n  min-width: 100px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var RULES_TAB = 'RULES';
var DATASHEET_TAB = 'DATASHEETS';
var selectWidth = (0, _emotion.css)(_templateObject());
var flex = (0, _emotion.css)(_templateObject2());

var ConstraintsOverviewComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(ConstraintsOverviewComponent, _Component);

  var _super = _createSuper(ConstraintsOverviewComponent);

  function ConstraintsOverviewComponent() {
    var _this;

    _classCallCheck(this, ConstraintsOverviewComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      pendingConstraintName: '',
      keyMap: {},
      selectedTab: RULES_TAB,
      page: 1,
      itemsPerPage: _this.props.itemsPerPageList[0].value,
      itemsPerPageSelected: _this.props.itemsPerPageList[0]
    });

    _defineProperty(_assertThisInitialized(_this), "updateKeyMap", function (prevProps) {
      if (!(0, _isEqual["default"])(prevProps.constraints, _this.props.constraints)) {
        var _this$props$constrain = _this.props.constraints;
        _this$props$constrain = _this$props$constrain === void 0 ? {} : _this$props$constrain;
        var _this$props$constrain2 = _this$props$constrain.rules,
            rules = _this$props$constrain2 === void 0 ? [] : _this$props$constrain2;
        var keyMap = _this.state.keyMap;
        var topIndex = Math.max.apply(Math, [0].concat(_toConsumableArray(Object.keys(keyMap).map(function (key) {
          return parseInt(keyMap[key]);
        }))));
        var newKeyMap = rules.reduce(function (mapObj, rule) {
          return _objectSpread(_objectSpread({}, mapObj), {}, _defineProperty({}, rule.name, keyMap[rule.name] || ++topIndex));
        }, {});

        if (!(0, _isEqual["default"])(newKeyMap, keyMap)) {
          _this.setState({
            keyMap: newKeyMap
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      return _this.updateKeyMap({});
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      return _this.updateKeyMap(prevProps);
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeWithValidation", function (constraints) {
      _this.props.onChange({
        constraints: constraints,
        errors: constraints.rules ? (0, _flatMap["default"])(constraints.rules.map(function (rule) {
          return (0, _rules.ruleValidator)(rule).map(function (error) {
            return {
              name: rule.name,
              message: error
            };
          });
        })) : null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPageChange", function (_ref) {
      var selected = _ref.selected;

      _this.setState({
        page: selected + 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddFormClick", function (ruleName) {
      return !_this.props.allowDataSheets ? _this.onAddConstraint(ruleName) : _this.setState({
        pendingConstraintName: ruleName
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddConstraint", function (ruleName) {
      _this.onChangeWithValidation(_objectSpread(_objectSpread({}, _this.props.constraints), {}, {
        rules: (0, _constraintActions.addRule)(_this.props.constraints.rules, ruleName)
      }));

      _this.clearPendingConstraintName();

      _this.setState({
        page: 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearPendingConstraintName", function () {
      return _this.setState({
        pendingConstraintName: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateRule", function (ruleName) {
      if (!ruleName) {
        return '';
      }

      var _this$props$constrain3 = _this.props.constraints,
          rules = _this$props$constrain3.rules,
          dataSheets = _this$props$constrain3.dataSheets;
      return (0, _keyValidators.validateRuleName)(ruleName, rules, 'Rule') || (0, _keyValidators.validateRuleName)(ruleName, dataSheets, 'Data Sheet');
    });

    _defineProperty(_assertThisInitialized(_this), "addCompleteOptionConstraint", function (constraint) {
      var constraints = _this.props.constraints;

      _this.onChangeWithValidation(_objectSpread(_objectSpread({}, constraints), {}, {
        rules: [constraint].concat(constraints.rules)
      }));

      _this.setState({
        page: 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateRule", function (name, rule) {
      if (rule && rule.name && name !== rule.name) {
        var keyMap = _this.state.keyMap;

        _this.setState({
          keyMap: _objectSpread(_objectSpread({}, keyMap), {}, _defineProperty({}, rule.name, keyMap[name]))
        });
      }

      var constraints = _this.props.constraints;

      _this.onChangeWithValidation(_objectSpread(_objectSpread({}, constraints), {}, {
        rules: (0, _constraintActions.updateRule)(constraints.rules, name, rule)
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onAddDataSheet", function (name) {
      var constraints = _this.props.constraints;

      _this.onChangeWithValidation(_objectSpread(_objectSpread({}, constraints), {}, {
        dataSheets: (0, _constraintActions.addDataSheet)(constraints.dataSheets, name)
      }));

      _this.clearPendingConstraintName();
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateDataSheet", function (dataSheets) {
      var constraints = _this.props.constraints;

      _this.onChangeWithValidation(_objectSpread(_objectSpread({}, constraints), {}, {
        dataSheets: dataSheets
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteDataSheet", function (deleteKey) {
      var constraints = _this.props.constraints;

      _this.onChangeWithValidation(_objectSpread(_objectSpread({}, constraints), {}, {
        dataSheets: (0, _constraintActions.deleteDataSheet)(constraints.dataSheets, deleteKey)
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "changeItemsPerPage", function (itemsPerPageSelected) {
      _this.setState({
        itemsPerPageSelected: itemsPerPageSelected,
        itemsPerPage: itemsPerPageSelected.value,
        page: 1
      });
    });

    return _this;
  }

  _createClass(ConstraintsOverviewComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          shouldPaginate = _this$props.shouldPaginate,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? [] : _this$props$options,
          _this$props$constrain4 = _this$props.constraints,
          constraints = _this$props$constrain4 === void 0 ? {} : _this$props$constrain4,
          allowDataSheets = _this$props.allowDataSheets,
          itemsPerPageList = _this$props.itemsPerPageList,
          getRuleError = _this$props.getRuleError,
          formatMessage = _this$props.intl.formatMessage;
      var _constraints$rules = constraints.rules,
          rules = _constraints$rules === void 0 ? [] : _constraints$rules,
          _constraints$dataShee = constraints.dataSheets,
          dataSheets = _constraints$dataShee === void 0 ? [] : _constraints$dataShee;
      var _this$state = this.state,
          pendingConstraintName = _this$state.pendingConstraintName,
          keyMap = _this$state.keyMap,
          selectedTab = _this$state.selectedTab,
          page = _this$state.page,
          itemsPerPage = _this$state.itemsPerPage,
          itemsPerPageSelected = _this$state.itemsPerPageSelected;
      var pageCount = Math.ceil(rules.length / itemsPerPage);
      var minIndex = itemsPerPage * (page - 1);
      var maxIndex = itemsPerPage * page;

      var rulesTabCotent =
      /*#__PURE__*/
      _react["default"].createElement("div", null, rules.length ?
      /*#__PURE__*/
      _react["default"].createElement(_react.Fragment, null, shouldPaginate ?
      /*#__PURE__*/
      _react["default"].createElement(_react.Fragment, null, rules.slice(minIndex, maxIndex).map(function (rule, index) {
        if (minIndex > 0) {
          index += minIndex;
        }

        return (
          /*#__PURE__*/
          _react["default"].createElement(_constraintComponent["default"], {
            key: keyMap[rule.name],
            options: options,
            constraintRules: rules,
            constraintRule: rule,
            onChange: _this2.onUpdateRule,
            addCompleteOptionConstraint: _this2.addCompleteOptionConstraint,
            errorMessage: getRuleError(rule)
          })
        );
      })) :
      /*#__PURE__*/
      _react["default"].createElement(_react.Fragment, null, rules.map(function (rule, i) {
        return (
          /*#__PURE__*/
          _react["default"].createElement(_constraintComponent["default"], {
            key: keyMap[rule.name],
            options: options,
            constraintRules: rules,
            constraintRule: rule,
            onChange: _this2.onUpdateRule,
            addCompleteOptionConstraint: _this2.addCompleteOptionConstraint,
            errorMessage: getRuleError(rule)
          })
        );
      })), shouldPaginate &&
      /*#__PURE__*/
      _react["default"].createElement(_react.Fragment, null,
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: flex
      },
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: selectWidth
      },
      /*#__PURE__*/
      _react["default"].createElement(_reactComponents.Select, {
        label: "Per Page",
        options: itemsPerPageList,
        isSearchable: false,
        value: itemsPerPageSelected,
        onChange: this.changeItemsPerPage,
        isClearable: false
      })),
      /*#__PURE__*/
      _react["default"].createElement("div", null,
      /*#__PURE__*/
      _react["default"].createElement(_reactComponents.Pagination, {
        pageCount: pageCount,
        onPageChange: this.onPageChange,
        pagesOutsideElipses: 1,
        pagesBetweenElipses: 3,
        forcePage: page - 1
      }))))) :
      /*#__PURE__*/
      _react["default"].createElement("div", null, formatMessage(_messages["default"].noRulesConfigured)));

      var dataSheetsContent =
      /*#__PURE__*/
      _react["default"].createElement("div", null, allowDataSheets ?
      /*#__PURE__*/
      _react["default"].createElement(_dataSheetsContainer["default"], {
        dataSheets: dataSheets,
        options: options,
        updateDataSheets: this.onUpdateDataSheet,
        onDelete: this.onDeleteDataSheet
      }) : null);

      var tabContent = selectedTab === RULES_TAB ? rulesTabCotent : dataSheetsContent;
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react.Fragment, null,
        /*#__PURE__*/
        _react["default"].createElement(_addForm["default"], {
          onAdd: this.onAddFormClick,
          validateOption: this.validateRule
        }), pendingConstraintName ?
        /*#__PURE__*/
        _react["default"].createElement(_ruleOrDataSheetPrompt["default"], {
          name: pendingConstraintName,
          onDecided: this.clearPendingConstraintName,
          onAddConstraint: this.onAddConstraint,
          onAddDataSheet: this.onAddDataSheet
        }) : null,
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement(_reactComponents.NavTab, null,
        /*#__PURE__*/
        _react["default"].createElement(_reactComponents.NavTabItem, {
          active: selectedTab === RULES_TAB
        },
        /*#__PURE__*/
        _react["default"].createElement("button", {
          onClick: function onClick() {
            return _this2.setState({
              selectedTab: RULES_TAB
            });
          }
        }, "Rules")),
        /*#__PURE__*/
        _react["default"].createElement(_reactComponents.NavTabItem, {
          active: selectedTab === DATASHEET_TAB,
          disabled: !allowDataSheets
        },
        /*#__PURE__*/
        _react["default"].createElement("button", {
          disabled: !allowDataSheets,
          onClick: function onClick() {
            return _this2.setState({
              selectedTab: DATASHEET_TAB
            });
          }
        }, "Data Sheets"))), tabContent))
      );
    }
  }]);

  return ConstraintsOverviewComponent;
}(_react.Component);

_defineProperty(ConstraintsOverviewComponent, "propTypes", {
  constraints: _propTypes["default"].shape({
    dataSheets: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.dataSheetsShape)),
    rules: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.constraintRuleShape))
  }).isRequired,
  options: _propTypes["default"].objectOf(_propTypes["default"].shape(_propTypes2.optionShape)).isRequired,
  intl: _propTypes["default"].shape(_propTypes2.intlShape).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  allowDataSheets: _propTypes["default"].bool.isRequired,
  shouldPaginate: _propTypes["default"].bool,
  itemsPerPageList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number,
    label: _propTypes["default"].string
  })),
  getRuleError: _propTypes["default"].func
});

_defineProperty(ConstraintsOverviewComponent, "defaultProps", {
  shouldPaginate: true,
  itemsPerPageList: [{
    value: 5,
    label: '5'
  }, {
    value: 10,
    label: '10'
  }, {
    value: 25,
    label: '25'
  }, {
    value: 50,
    label: '50'
  }],
  getRuleError: function getRuleError() {
    return '';
  }
});

var _default = (0, _reactIntl.injectIntl)(ConstraintsOverviewComponent);

exports["default"] = _default;